import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import UserAvatar from './users/UserAvatar'
import { Popup, List, Menu } from 'semantic-ui-react'

import auth0js from 'auth0-js';
import { AUTH_CONFIG } from './auth0-variables';
const myauth0 = new auth0js.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid email email_verified roles exp picture nonce logins_count user_metadata'
});


class App extends Component {
    static propTypes = { 

    } 
    state = { 
        activeItem: 'gamepad',
    } 

    setSession(authResult) {
        // console.log('auth0', 'set session')
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify(
        authResult.expiresIn * 1000 + new Date().getTime()
        );
    
        if(
            authResult.idTokenPayload['https://app.brikl.io/logins_count'] &&
            authResult.idTokenPayload['https://app.brikl.io/logins_count'] < 4 &&
            (
                !localStorage.getItem('onboarding') ||
                localStorage.getItem('onboarding') === 'no'
            )
        ){
            localStorage.setItem('onboarding', 'yes');
        }else{
            localStorage.setItem('onboarding', 'no');
        }
        
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
        localStorage.setItem('email', authResult.idTokenPayload.email);

        // schedule a token renewal
        this.scheduleRenewal();

    }
    renewToken() {
        
        // console.log('auth0', 'renew')
        if(window.localStorage.getItem('expires_at')){
            myauth0.checkSession({},
            (err, result) => {
                if (err) {
                    // console.log('auth0', `Could not get a new token (${err.error}: ${err.error_description}).`);
                } else {
                    // alert('set session here 2')
                this.setSession(result);
                // console.log('auth0', `Successfully renewed auth!`);
                }
            }
            );
        }else{
            // console.log('auth0', 'logged out 1')
            clearTimeout(this.tokenRenewalTimeout)
        }
    }
    scheduleRenewal(){
            // console.log('auth0', 'schedule renewal')    
            const expiresAt = JSON.parse(window.localStorage.getItem('expires_at'));
            const diff = expiresAt - Date.now();
            const delay = 10800000 // every 3 hours
            if (delay > 0 && diff > 0) {
                // console.log('auth0', 'delay > 0 === '+delay)
            this.tokenRenewalTimeout = setTimeout(() => {
                this.renewToken();
            }, delay);
            }
        
        
    }

  
  componentDidMount(){
    myauth0.checkSession({

    },(err, result) => {
        if (err) {
            // alert(err)
            // console.log('auth0', `Could not get a new token (${err.error}: ${err.error_description}).`);
        } else {
            this.setSession(result);
            // console.log('auth0', `Successfully renewed auth!`);
        }
    });
    // this.scheduleRenewal();  
  }
  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render() {
    const { activeItem } = this.state
    return (
        <Popup
            className="account--menu"
            hideOnScroll
            trigger={ 
                <Menu.Item
                active={activeItem === 'filters'}
                onClick={this.handleItemClick}
                >
                {
                    this.props.UserQuery.loading ?
                    <div className="placeholder button login--btn">&nbsp;</div>
                    :
                        this.props.UserQuery.user && this.props.UserQuery.user.id ?
                        <UserAvatar className="user--profile__img" userid={this.props.UserQuery.user.id} />
                        :
                        <a href={'https://brikl.eu.auth0.com/login?redirectUrl='+AUTH_CONFIG.callbackUrl+'&client='+AUTH_CONFIG.clientId+'&nonce=ijsdfndfsjbcv&state=aG80OTRuZ2IxOWZtZzk0O'} className="button login--btn">
                            Login
                        </a>
                }
                </Menu.Item>
                }
            position='top center'
            on='click'
        >
            <List>            
                <List.Item><a rel="noopener noreferrer" target="_blank" href="https://app.brikl.io/account">Account</a></List.Item>
            </List>
        </Popup>
    //   <div className="AccountMenu">     
    //     {
    //         this.props.UserQuery.loading ?
    //             <div className="placeholder">&nbsp;</div>
    //         :
    //             this.props.UserQuery.user && this.props.UserQuery.user.id ?
    //             <UserAvatar className="user--profile__img" userid={this.props.UserQuery.user.id} />
    //             : 
                
    //     }
    //   </div>
    );
  }
}

const user = gql`query user{
  user{
    id,
    username      
  }  
}`




const AppWithData = compose(
 graphql(
   user, {
     name: 'UserQuery',
     options: {
       operation: 'query',      
       fetchPolicy : 'network-only'
     }
   }
 ),   
 )(App)
 
 export default withRouter(AppWithData)



// WEBPACK FOOTER //
// ./src/AccountMenu.jsx